import { withStyles, WithStyles } from "@mui/styles";
import { DashboardStyleClasses } from "assets/jss/common-styles";
import { AdvFilterResult, AutoCompleteKeyWord } from "components/AdvFilter";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiPaper from "components/MuiExtras/MuiPaper";
import { WithSnackbar, withSnackbar } from "components/SnackbarProvider/Snackbar";
import { DashboardAwardAnalysisFilter } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { AwardAnalysisBadgeList } from "views/Dashboards/AwardAnalysisDashboard/AwardAnalysisBadgeList";
import AwardAnalysisFilter from "views/Dashboards/AwardAnalysisDashboard/AwardAnalysisFilter";
import { AwardAnalysisGraph } from "views/Dashboards/AwardAnalysisDashboard/AwardAnalysisGraph";
import { AwardAnalysisIndicators } from "views/Dashboards/AwardAnalysisDashboard/AwardAnalysisIndicators";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    filter: DashboardAwardAnalysisFilter;
    advFilters: AdvFilterResult[];
}

type Props = {} & WithStyles<typeof DashboardStyleClasses> & WithSnackbar & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class AwardAnalysisDashboard extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);

        this.state = {
            filter: null,
            advFilters: []
        };
    }

    /////////////////////////////////////////////////////////////////////////////////////

    private getFilter(): DashboardAwardAnalysisFilter {
        const { advFilters } = this.state;

        var member = advFilters.find(p => p.keyword == AutoCompleteKeyWord);

        return {
            memberId: member == null
                ? null
                : member.value.key,
        };
    }

    /////////////////////////////////////////////////////////////////////////////////////

    private handleSelectUser = (userId: string, name: string, thumbnailUrl: string) => {

        this.setState(({ advFilters }) => {

            advFilters = advFilters.filter(p => p.keyword != AutoCompleteKeyWord);

            advFilters.push({
                keyword: AutoCompleteKeyWord,
                value: { key: userId, label: name, thumbnailUrl: thumbnailUrl } as AutoCompleteDataModel,
                text: name
            });

            return { advFilters };
        });

        this.props.snackbar.showMessage(this.props.t("Views.Dashboards.Common.FilteringBy", { name: name }));
    };

    /////////////////////////////////////////////////////////////////////////////////////

    render() {
        const { advFilters } = this.state;

        var filter = this.getFilter();

        return (
            <div className={this.props.classes.dashboardLargeContainer}>

                <AwardAnalysisFilter
                    advFilters={advFilters}
                    commands={null}
                    onFilterChange={(advFilters) => this.setState({ advFilters })}
                />

                <MuiContainer margin="normal">
                    <MuiPaper borderVariant="accentedRound" borderColor="warning">
                        <AwardAnalysisIndicators
                            filter={filter}
                        />
                    </MuiPaper>
                </MuiContainer>

                <MuiContainer margin="normal">
                    <MuiPaper borderVariant="accentedRound" borderColor="warning">
                        <AwardAnalysisGraph
                            filter={filter}
                            onSelectUser={this.handleSelectUser}
                        />
                    </MuiPaper>
                </MuiContainer>

                <MuiContainer margin="normal">
                    <MuiPaper borderVariant="accentedRound" borderColor="warning">
                        <AwardAnalysisBadgeList
                            filter={filter}
                        />
                    </MuiPaper>
                </MuiContainer>

            </div>
        );
    }
}

export default withSnackbar(withTranslation()(withStyles(DashboardStyleClasses)(AwardAnalysisDashboard)));